import { AuditStatus, ChecklistItemStatus } from '@fsp/types';
import {
  CheckCircleOutlined,
  WarningAmberOutlined,
  VisibilityOutlined,
  RadioButtonUncheckedOutlined,
} from '@mui/icons-material';
import React from 'react';

export const getAuditStatusColor = (status: AuditStatus) => {
  switch (status) {
    case AuditStatus.IN_PROGRESS:
      return 'info';
    case AuditStatus.COMPLETED:
      return 'warning';
    case AuditStatus.RESOLVED:
      return 'success';
    case AuditStatus.ARCHIVED:
      return 'default';
    default:
      return 'default';
  }
};

export const getAuditStatusLabel = (status: AuditStatus) => {
  switch (status) {
    case AuditStatus.IN_PROGRESS:
      return 'In Progress';
    case AuditStatus.COMPLETED:
      return 'Completed';
    case AuditStatus.RESOLVED:
      return 'Resolved';
    case AuditStatus.ARCHIVED:
      return 'Archived';
    default:
      return status;
  }
};

export const getChecklistItemStatusIcon = (status: ChecklistItemStatus) => {
  switch (status) {
    case ChecklistItemStatus.SATISFACTORY:
      return <CheckCircleOutlined sx={{ fontSize: 18, color: 'success.main' }} />;
    case ChecklistItemStatus.NON_CONFORMITY:
      return <WarningAmberOutlined sx={{ fontSize: 18, color: 'warning.main' }} />;
    case ChecklistItemStatus.OBSERVATION:
      return <VisibilityOutlined sx={{ fontSize: 18, color: 'info.main' }} />;
    case ChecklistItemStatus.NOT_CHECKED:
      return <RadioButtonUncheckedOutlined sx={{ fontSize: 18, color: 'text.disabled' }} />;
    default:
      return null;
  }
};

export const getChecklistItemStatusLabel = (status: ChecklistItemStatus) => {
  switch (status) {
    case ChecklistItemStatus.NOT_CHECKED:
      return 'Not Checked';
    case ChecklistItemStatus.SATISFACTORY:
      return 'Satisfactory';
    case ChecklistItemStatus.NON_CONFORMITY:
      return 'Non-Conformity';
    case ChecklistItemStatus.OBSERVATION:
      return 'Observation';
    default:
      return status;
  }
};
